import React from 'react';

import { useNavigate, Link } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';

import { School } from 'app/types';

import Loader from 'common/components/Loader/Loader';
import { navigateTop } from 'common/utils';
import { detailUrl } from 'common/utils/conversions';

import { useGetSchoolSimilarsQuery } from 'services/exploreApi';

import styles from './Tabs.module.scss';
import textStyles from 'common/styles/text.module.scss';
import Text from 'common/components/Text/Text';
import { useAppDispatch } from 'app/hooks';
import { setFromExplore } from 'features/explore/exploreSlice';
import { newDetailUrl } from 'common/utils/conversions';

interface CompProps {
  schoolId: number;
  similarSchoolsRef: React.RefObject<HTMLDivElement>;
  comesFromExplore?: boolean;
}

const SimilarSchools = ({
  schoolId,
  similarSchoolsRef,
  comesFromExplore,
}: CompProps): React.ReactElement => {
  const { data: schools, isLoading } = useGetSchoolSimilarsQuery(schoolId);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const navigateTo = (route: string) => {
    navigateTop();
    dispatch(setFromExplore(false));
    navigate(route);
  };
  const isMobile = useMediaQuery({ maxWidth: 768 });
  if (isLoading) return <Loader />;
  return (
    <div className={styles.similarSchoolsContainer} ref={similarSchoolsRef} id="similar-schools">
      <div className={styles.sectionTitle}>
        <div className={styles.blueBlock} />
        {comesFromExplore ? (
          <h3 className={styles.titleText}>Similar schools</h3>
        ) : (
          <h2 className={styles.titleText}>Similar schools</h2>
        )}
      </div>
      <div className={styles.sectionSchool}>
        {schools?.data.data.map((school: School) => (
          <div
            className={styles.schoolCard}
            key={school.id}
            onClick={
              !isMobile
                ? () => {
                    navigateTop();
                    navigate(newDetailUrl('schools', school.id, school.name));
                  }
                : undefined
            }
          >
            <div className={styles.firstRow}>
              <div className={styles.logo}>
                <img src={school.logo} alt={`Logo of ${school.name}`} className={styles.logo} />
              </div>
              <Text weight={600} size={isMobile ? 14 : 16}>
                {school.name}
              </Text>
              <div className={styles.recommended} />
            </div>
            <div className={styles.secondRow}>
              <div className={styles.firstLine}>
                <Text size={isMobile ? 14 : 16} weight={600}>
                  {school.tuition_range}
                </Text>
                {school.first_ranking && (
                  <Text size={isMobile ? 12 : 16} weight={400}>
                    , #{school.first_ranking}
                  </Text>
                )}
              </div>
              <div className={styles.secondLine}>
                <i className="bi bi-geo-alt" />
                <Text size={isMobile ? 14 : 16}>
                  {school.city.name}, {school.city.country.name}
                </Text>
              </div>
            </div>
            {isMobile && (
              <>
                <hr className={styles.breakline} />
                <button
                  className={`${styles.detailButton} btn`}
                  onClick={() => {
                    navigateTo(newDetailUrl('schools', school.id, school.name));
                  }}
                >
                  See details
                </button>
              </>
            )}
            {/* {!isMobile && (
                  <div className={`d-flex flex-row justify-content-end ${styles.endContainer}`}>
                    <Link
                      to={detailUrl('schools', school.id, school.name)}
                      onClick={() => navigateTop()}
                    >
                      <div className={`d-flex flex-row justify-content-end ${styles.endRow}`}>
                        <p>View more</p>
                        <i className="bi bi-chevron-right"></i>
                      </div>
                    </Link>
                  </div>
                )} */}
          </div>
        ))}
      </div>
    </div>
  );
};

export default SimilarSchools;
